/**
 * Utility function to get authenticated headers for API requests
 * Includes the JWT token from localStorage if available
 * Generates a unique request ID for multi-pod request correlation
 */
export const getAuthHeaders = (): HeadersInit => {
  const token = localStorage.getItem('token');
  
  // Generate unique request ID for tracking across multiple pods
  const requestId = `client-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
  
  const headers: HeadersInit = {
    'Accept': 'application/json, text/plain',
    'Content-Type': 'application/json;charset=UTF-8',
    'X-Custom-Header': 'mb-cashback-2025-header',
    'X-Client-Request-ID': requestId, // For request correlation across pods
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  return headers;
};
